import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  titleRoot: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 10,
  },
  titleText: {
    ...theme.hv.typography.highlightText,
  },
  content: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    paddingLeft: 0,
    paddingRight: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  contentText: {
    textTransform: "capitalize",
  },
  indicatorIcon: {
    marginLeft: theme.hv.spacing.sm,
    marginRight: theme.hv.spacing.sm,
  },
}));
export default styles;
